import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";
export const TICKET = {
  getAllCounterpartList: {
    success: "GET_ALL_COUNTERPART_SUCCESS"
  },
  getOriginType: {
    success: "GET_ALL_ORIGIN_TYPE_SUCCESS"
  },
  getAllTicketsList: {
    start: "GET_ALL_TICKET_START",
    success: "GET_ALL_TICKET_SUCCESS",
    error: "GET_ALL_TICKET_ERROR"
  },
  getTicketsList: {
    start: "GET_TICKETS_START",
    success: "GET_TICKETS_SUCCESS",
    error: "GET_TICKETS_ERROR"
  },
  getCounterPartyTicketsList: {
    start: "GET_COUNTERPARTYTICKETS_START",
    success: "GET_COUNTERPARTYTICKETS_SUCCESS",
    error: "GET_COUNTERPARTYTICKETS_ERROR"
  },
  getCounterPartyTicketsListData: {
    start: "GET_COUNTERPARTYTICKETS_DATA_START",
    success: "GET_COUNTERPARTYTICKETS_DATA_SUCCESS",
    error: "GET_COUNTERPARTYTICKETS_DATA_ERROR",
  },
  getCounterPartyDashboardData: {
    start: "GET_DASHBOARD_DATA_START",
    success: "GET_DASHBOARD_DATA_START_DATA_SUCCESS",
    error: "GET_DASHBOARD_DATA_START_DATA_ERROR",
  },
  getCounterPartyHarvestdData: {
    start: "GET_HARVEST_DATA_START",
    success: "GET_HARVEST_DATA_START_DATA_SUCCESS",
    error: "GET_HARVEST_DATA_START_DATA_ERROR",
  },
  getCounterPartyDashboardDataByOne: {
    start: "GET_DASHBOARD_DATA_ByOne_START",
    success: "GET_DASHBOARD_DATA_START_DATA_ByOne_SUCCESS",
    error: "GET_DASHBOARD_DATA_START_DATA_ByOne_ERROR",
  },
  create: {
    success: "TICKET_CREATE_SUCCESS",
    error: "TICKET_CREATE_ERROR"
  },
  edit: {
    success: "TICKET_EDIT_SUCCESS",
    selected: "EDIT_SELCTED_TICKET"
  },
  delete: {
    success: "TICKET_DELETE_SUCCESS",
    locked: "TICKET_DELETE"
  },
  loadNumberIndicator: {
    success: "LOAD_NUMBER_INDICATOR_LIST"
  },
  indicatorCodeCount: {
    success: "LOAD_NUMBER_INDICATOR_CODE_COUNT"
  },
  setSearchTerm: {
    success: "SET_SEARCH_TERM_SUCCESS"
  },
  setGroupBy: {
    success: "SET_GROUP_BY_SUCCESS"
  },
  setPreviousDays: {
    success: "SET_PREVIOUS_DAYS_SUCCESS"
  },
  setPreviousFarmsDays:{
    success: "SET_PREVIOUS_DAYS_FARMS_SUCCESS"
  }
};

export const getAllTicketList = (
  id,
  harvestYear = harvestYearDetail().name
) => {
  let url = `/ntrac/ticket/farmId/${id}?harvestYear=${harvestYear}`;
  return dispatch => {
    return globalApiHandler(url, "get", {})
      .then(response => {
        const responseData = response.data.data;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] = responseData[value].contractNumber;
          return responseData[value];
        });
        dispatch({ type: TICKET.getAllTicketsList.success, data: data });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};
export const getTicketList = (
  id,
  harvestYear = harvestYearDetail().name,
  pageNumber = 0,
  recordsPerPage = 50,
  searchTerm = ""
) => {
  let url = `/ntrac/ticket/ticketList/${id}?pageNumber=${pageNumber}&recordsPerPage=${recordsPerPage}&harvestYear=${harvestYear}`;
  url = searchTerm ? `${url}&ticketNumberContainingString=${searchTerm}` : url;
  return dispatch => {
    dispatch({ type: TICKET.getTicketsList.start, data: "" });
    return globalApiHandler(url, "get", {})
      .then(response => {
        const responseData = response.data.data;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] = responseData[value].contractNumber;
          return responseData[value];
        });
        const totalPages = response.data.pageData.totalPages;
        const totalElements = response.data.pageData.totalElements;
        dispatch({
          type: TICKET.getTicketsList.success,
          data: { data, totalPages, totalElements }
        });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getCounterPartyTicketList = ( groupByValue
) => {
  let url = `/ntrac/counterparty/getFarmForCounterParty`;
  return dispatch => {
    dispatch({ type: TICKET.getCounterPartyTicketsList.start, data: "" });
    return globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({
          type: TICKET.getCounterPartyTicketsList.success,
          data: { data }
        });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};
export const getTicketsForCounterParty = ( farmid, harvestYear, pageCount, pageNo,groupByValue, previousDays
) => {
  console.log( previousDays,"check")
  let url = `/ntrac/counterparty/getTicketsForCounterParty/${farmid}?count=${pageCount}&days=${previousDays===100000?"":previousDays}&harvestYear=${harvestYear}&pageNumber=${pageNo}`;
  return dispatch => {
    dispatch({ type: TICKET.getCounterPartyTicketsListData.start, data: "" });
    return globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({
          type: TICKET.getCounterPartyTicketsListData.success,
          data: { data }
        });
        return true;
      })
      .catch(err => {
        dispatch({ type: TICKET.getCounterPartyTicketsListData.error, data: "" });
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};
export const getCounterPartyDashboard = ( days
  ) => {
    
    let url = `/ntrac/counterparty/getTicketsOverViewPage?days=${days}`;
    return dispatch => {
      dispatch({ type: TICKET.getCounterPartyDashboardData.start, data: "" });
      return globalApiHandler(url, "get", {})
        .then(response => {
          const data = response.data;
          console.log(data,'data')
          for(let i=0;i<data.length;i++){
            data[i]['truckLine'] = data[i].truckline.name 
            data[i]['commodity'] = data[i].commodityResponseDTO.name 
            data[i]['destination'] = data[i].destinationResponseDTO.name
          }
          console.log(data,'data2')
          dispatch({
            type: TICKET.getCounterPartyDashboardData.success,
            data: { data }
          });
          return true;
        })
        .catch(err => {
          dispatch({ type: TICKET.getCounterPartyDashboardData.error, data: "" });
          dispatch({ type: "SERVER_ERROR", data: err.data });
        });
    };
  };
  export const getDataFromHarvestYear= ( harvestYear
    ) => {
      
      let url = `/ntrac/report/counterparty/dropdown/${harvestYear}`;
      return dispatch => {
        dispatch({ type: TICKET.getCounterPartyHarvestdData.start, data: "" });
        return globalApiHandler(url, "get", {})
          .then(response => {
            const data = response.data;
            console.log(data,'checkkkkk')
            dispatch({
              type: TICKET.getCounterPartyHarvestdData.success,
              data: { data }
            });
            return true;
          })
          .catch(err => {
            dispatch({ type: TICKET.getCounterPartyHarvestdData.error, data: "" });
            dispatch({ type: "SERVER_ERROR", data: err.data });
          });
      };
    };
  export const getCounterPartyDashboardbyoneday = (
    ) => {
      
      let url = `/ntrac/counterparty/getTicketsOverViewPage?days=${1}`;
      return dispatch => {
        dispatch({ type: TICKET.getCounterPartyDashboardDataByOne.start, data: "" });
        return globalApiHandler(url, "get", {})
          .then(response => {
            const data = response.data;
            dispatch({
              type: TICKET.getCounterPartyDashboardDataByOne.success,
              data: { data }
            });
            return true;
          })
          .catch(err => {
            dispatch({ type: TICKET.getCounterPartyDashboardDataByOne.error, data: "" });
            dispatch({ type: "SERVER_ERROR", data: err.data });
          });
      };
    };
export const getCounterpartList = () => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
      // let url = `/ntrac/counterpart/counterpartList/${
      //   userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
      // }?harvestYear=${harvestYearDetail().name}`;
    let url = `/ntrac/counterpart/getAllCounterPartyForTicketAndContractScreen?farmId=${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }&harvestYear=${harvestYearDetail().name}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        // const responseData = response.data.data;
        let responseData ={}
        responseData = response.data;
        // const suggestedResponseData = response.data.suggestedData;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] =
            responseData[value].name +
            " (" +
            responseData[value].counterpartTypeResponseDTO.name +
            ")" + `${responseData[value].onBoarded?'    ✅':''}` + `${!responseData[value].paymentStatus && responseData[value].onBoarded?'    ⚠️':''}`;
          return responseData[value];
        });

        // let suggestedData = Object.keys(suggestedResponseData).map(value => {
        //   suggestedResponseData[value]["name"] =
        //     suggestedResponseData[value].name +
        //     " (" +
        //     suggestedResponseData[value].counterpartTypeResponseDTO.name +
        //     ")";
        //   return suggestedResponseData[value];
        // });
        dispatch({
          type: TICKET.getAllCounterpartList.success,
          data,
          // suggestedData
        });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getOriginType = () => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
    let url = `/ntrac/fieldgroup/farmFields/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }/${harvestYearDetail().name}`;
    return globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        const suggestedData = response.data.suggestedData;
        dispatch({ type: TICKET.getOriginType.success, data, suggestedData });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createNewTicket = ticketInfo => {
  let url = `/ntrac/ticket`;
  let date = new Date(ticketInfo.loadDate);
  // ticketInfo['loadDate'] = ticketInfo.loadDate
  return dispatch => {
    globalApiHandler(url, "post", ticketInfo)
      .then(response => {
        dispatch({ type: TICKET.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};
export const updateTicket = ticketInfo => {
  let url = `/ntrac/ticket/ticketnum/${ticketInfo.ticketNumber}`;
  return dispatch => {
    globalApiHandler(url, "put", ticketInfo)
      .then(response => {
        dispatch({ type: TICKET.edit.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};
export const deleteTicket = ticketId => {
  let url = `/ntrac/ticket/disable/${ticketId}`;
  return dispatch => {
    globalApiHandler(url, "put", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: TICKET.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
        return data;
      })
      .catch(err => {
        if (err.status === 423) {
          dispatch({ type: "SERVER_SUCCESS", data: err.data });
        } else {
          dispatch({ type: "SERVER_ERROR", data: err.data });
        }
      });
  };
};
export const setGroupByAction = (value) => {
  return dispatch => {
    dispatch({ type: TICKET.setGroupBy.success, data: value });
  };
}
export const setPreviousDaysAction = (value) => {
  return dispatch => {
    dispatch({ type: TICKET.setPreviousDays.success, data: value });
  };
}
export const setPreviousDaysFarmsAction = (value) => {
  return dispatch => {
    dispatch({ type: TICKET.setPreviousFarmsDays.success, data: value });
  };
}
export const editSelectedTicket = data => {
  return dispatch => {
    dispatch({ type: TICKET.edit.selected, data });
    dispatch({ type: "FILLING_FORM_MODE", data: true });
  };
};
export const FillingForm = () => {
  return dispatch => {
    dispatch({ type: "FILLING_FORM_MODE", data: true });
  };
};

export const clearErrorMessage = () => {
  return dispatch => {
    dispatch({ type: "CLEAR_ERROR" });
  };
};

export const getLoadNumberIndicatorList = (
  harvestYear = harvestYearDetail().name
) => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
    let url = `/ntrac/fieldgroup/loadnumberindicator/loadnumberindicatorList/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }/${harvestYear}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const responseData = response.data.data;
        const suggestedResponseData = response.data.suggestedData;
        let data = Object.keys(responseData).map(value => {
          responseData[value]["name"] = responseData[value].type;
          return responseData[value];
        });
        let suggestedData = Object.keys(suggestedResponseData).map(value => {
          suggestedResponseData[value]["name"] =
            suggestedResponseData[value].type;
          return suggestedResponseData[value];
        });
        dispatch({
          type: TICKET.loadNumberIndicator.success,
          data,
          suggestedData
        });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getLoadIndicatorCodeCount = (
  code,
  harvestYear = harvestYearDetail().name
) => {
  return (dispatch, getState) => {
    const selectedFarmId = getState().FarmManagementReducer.SubFarmId;
    let url = selectedFarmId
      ? `/ntrac/fieldgroup/loadnumberindicator/${code}/${harvestYear}?farmId=${selectedFarmId}`
      : `/ntrac/fieldgroup/loadnumberindicator/${code}/${harvestYear}`;
    return globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data;
        dispatch({ type: TICKET.indicatorCodeCount.success, data });
        return data;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const setSearchTerm = keyword => {
  return dispatch => {
    console.log(keyword);
    dispatch({ type: TICKET.setSearchTerm.success, data: keyword });
  };
};



// WEBPACK FOOTER //
// ./src/modules/ticket/action.js